const MapModal = () => import("@/components/common/mapModal/Index");

//按需加载
import {} from '../../../../api/api'

export default {
	name: 'icon-library',
	props: {
		state: String,
		id: String,
		close: Function
	},
	components: {
		MapModal
	},
	data() {
		return {
			iconLibrary: {
				//title: this.state == "add" ? "管理图标库" : "管理图标库",
				title: "管理图标库",
				id: "iconLibrary",
			},
			modalNode: {
				iconLibrary: {
					show: true,
					loading: false,
					// 样式配置 定位使用
					// style: "margin: 106px 0 0 -706px;",
					offset: {
						// 默认弹出层偏移
						x: 55,
						y: -666,
			  	// unit: "px", // 默认px
					},
					// width: "450px",
					// auto 自适应
					height: "auto",
					//模态框head配置
			  head: {
						//是否能拖动
						canmove: {
							//当前拖动状态
							state: true,
						},
						//折叠配置
						fold: {
							//当前折叠状态
							state: true,
						}
			 	},
			  //模态框中心配置
					// content: {
					//   type: "form",
					//   formData: {
			  //     parentId: {
					//       type: "select",
					//       title: "所属目录",
					//       disabled: false,
					//       options: [
			  //         {
					//           name: "根目录",
					//           parentId: "-1",
					//           id: "0",
			 	//           surveilType: "directory",
					//         },
					//       ],
					//     },
					//     name: {
					//       md: 24,
					//       type: "textarea",
					//       title: "目录名称",
					//       rows: 2,
					//       disabled: false,
			  //       placeholder: "请填写所属文本",
					//     },
					//     // checkbox: {
					//     //   md: 24,
					//     //   type: "checkbox",
					//     //   title: "复选框",
					//     //   disabled: false,
					//     // },
					//     // parentId1: {
					//     //   md: 24,
					//     //   icon: "$",
					//     //   type: "input",
					//     //   title: "输入框",
			 	//     //   placeholder: "请输入",
					//     // },
					//     // parentId2: {
					//     //   md: 12,
					//     //   type: "input",
			 	//     //   title: "所属分类",
					//     // },
					//   },
					//   rules: {
					//     parentId: [
					//       {
					//         required: true,
					//         message: "请选择所属目录",
					//         trigger: "blur",
					//       },
					//     ],
					//     name: [
					//       {
					//         required: true,
					//         message: "请输入目录名称",
					//         trigger: "blur",
					//       },
					//     ],
					//   },
					// },
				},
			},
			// submitData: {
			//   parentId: "根目录",
			//   name: "",
			// },
			iconLibrary_submit_disabled: false,
			form: {
				id: '',
				parentId: '',
				name: '',
			},

			rules: {
				parentId: [{
					required: true,
					message: '请选择所属目录',
					trigger: 'blur'
				}],
				name: [{
					required: true,
					message: '请输入目录名称',
					trigger: 'blur'
				}]
			},
			isEdit: false,
			data: {},

			//请求后端标记目录树时，记得在顶部添加一项，{value: '0',label: '根目录'},保障下拉框至少有一项，且可以新建目录树。
			options: [{
				name: "根目录",
				parentId: "-1",
				id: "0",
				markType: "directory"
			}],
			dialogVisible:false,
			dialogImageUrl:'',
			fileList: [{name: 'food.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}, {name: 'food2.jpeg', url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg95.699pic.com%2Fxsj%2F0p%2Fsa%2Fj1.jpg%21%2Ffw%2F700%2Fwatermark%2Furl%2FL3hzai93YXRlcl9kZXRhaWwyLnBuZw%2Falign%2Fsoutheast&refer=http%3A%2F%2Fimg95.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656591880&t=79ae5a7bd848d8449d9cc848e08b99c7'}]
		};
	},
	methods: {
		handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		onSubmit() {
			this.$refs.form.validate((valid) => {
				if (valid) {
					/* 表单提交后3秒内不可重复点击 */
					this.iconLibrary_submit_disabled = true;
					let that = this;
					//console.log(this);
					setTimeout(function() {
						that.iconLibrary_submit_disabled = false;
					}, 3000);

					const formData = JSON.parse(JSON.stringify(this.form));
					// console.log(formData);
					formData.markType = 'directory'; //指明添加的数据为文件类型。
					// console.log(formData);
					if (this.isEdit) {
						//axios请求编辑数据。

						let mdeData = {
							projectId: parseInt(window.sessionStorage.getItem('nowProjectId')),
							pid: this.form.parentId,
							name: this.form.name,
							markType: 'content', //数据库里marktype为content表示是目录，但是前端程序里markType为directory表示是目录。
							id: this.form.id,
							owner: true, //默认共享目录。
						}
						// editMark(mdeData).then(res => {
						// 	//console.log(JSON.parse(JSON.stringify(res)));
						// 	//console.log(3333333333333333333);
						// 	if (res.data.success && res.data.code === 204) {

						// 		//表单验证设置了下拉框必选，需要将未选择下拉框和选择根目录区分开，而目录树里的根目录parentId是'',不是'0'。数据库里parentId为0表示上级是根目录。
						// 		// // 本地更新目录树
						// 		// if (formData.parentId === '0') {
						// 		// 	formData.parentId = '';
						// 		// }
						// 		// this.$emit('edit_iconLibrary', formData);

						// 		// 改为：直接通知父组件刷新数据
						// 		that.$parent.initTreeData();

						// 		that.$notify({
						// 			title: '已成功更新标记目录。',
						// 			message: '',
						// 			type: 'success',
						// 			duration: 960,
						// 			offset: 320
						// 		});

						// 	} else {
						// 		that.$alert('修改标记目录保存失败了，请再试一次吧~', '编辑失败', {
						// 			confirmButtonText: '确定',
						// 			type: 'error',
						// 			callback: action => {}
						// 		});
						// 	}
						// });
					} else {
						//axios请求新增数据。
						let mdaData = {
							projectId: parseInt(window.sessionStorage.getItem('nowProjectId')),
							pid: this.form.parentId,
							name: this.form.name,
							markType: 'content', //数据库里marktype为content表示是目录，但是前端程序里markType为directory表示是目录。
							owner: true, //默认共享目录。
						}
						// addMark(mdaData).then(res => {
						// 	//console.log(JSON.parse(JSON.stringify(res)));
						// 	//console.log(3333333333333333333);
						// 	if (res.data.success && res.data.code === 204) {

						// 		//表单验证设置了下拉框必选，需要将未选择下拉框和选择根目录区分开，而目录树里的根目录parentId是'',不是'0'。数据库里parentId为0表示上级是根目录。
						// 		// // 本地更新目录树
						// 		// if (formData.parentId === '0') {
						// 		// 	formData.parentId = '';
						// 		// }
						// 		// // 随机生成id(仅为前端模拟使用，正常场景应为后台数据库新增记录成功后返回的主键Id)
						// 		// formData.id = Math.random();
						// 		// //新增目录树数据
						// 		// this.$emit('add_iconLibrary', formData);

						// 		// 改为：直接通知父组件刷新数据
						// 		that.$parent.initTreeData();

						// 		that.$notify({
						// 			title: '已成功新增标记目录。',
						// 			message: '',
						// 			type: 'success',
						// 			duration: 960,
						// 			offset: 320
						// 		});

						// 	} else {
						// 		that.$alert('添加标记目录失败了，请再试一次吧~', '添加失败', {
						// 			confirmButtonText: '确定',
						// 			type: 'error',
						// 			callback: action => {}
						// 		});
						// 	}
						// });
					}
					this.iconLibrary_click();
				}
			})
		},

		addDirectory(fdata) {
			//fdata为目录选项数据。
			if (fdata == undefined || fdata.length <= 0) {
				fdata = [];
			}
			this.isEdit = false;
			this.title = '新增';
			this.initFormData();
			this.$refs.form.resetFields();
			fdata.unshift({
				name: "根目录",
				parentId: "-1",
				id: "0",
				markType: "directory"
			});
			this.options = fdata;
		},
		editDirectory(data, fdata) {
			//data为编辑数据，fdata为目录选项数据。
			if (fdata == undefined || fdata.length <= 0) {
				fdata = [];
			}
			fdata.unshift({
				name: "根目录",
				parentId: "-1",
				id: "0",
				markType: "directory"
			});

			if (!data.parentId) {
				data.parentId = '0';
			}
			this.options = fdata;
			this.form = data;
			this.data = data; //这个this.data是方便页面里的删除按钮传值的。
			this.isEdit = true;
			this.title = '编辑';
		},
		initFormData() {
			// this.form = {
			// 	parentId: '',
			// 	name: '',
			// }
			this.modalNode.iconLibrary.loading = false;
		},
		deleteDirectory() {
			if (this.data && this.data.id) {
				this.$parent.deleteTreeItem(this.data);
			} else {
				this.$alert('删除失败，因为发生了数据错误', '友情提示', {
					confirmButtonText: '确定',
					callback: action => {}
				});
			}
		},
		iconLibrary_click() {
			this.$refs.form.resetFields();
			this.$emit('iconLibrary_close');
		},
	},
	watch: {
		state(newName, oldName) {
			console.log(newName);
			if (newName == "add") {
				this.iconLibrary.title = "添加";
				this.submitData.parentId = "";
				this.submitData.name = "";
			} else {
				this.iconLibrary.title = "编辑";
			}
		},
	},
	mounted() {
		this.initFormData();
	}
}
